import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthDetails, selectSharedDetails } from './redux/selectors';
import { RootState } from './redux/reducers';
import { NotificationToaster } from './components/common';
import { connectSocket } from './service/socket.service';
import { patientConnected } from './redux/reducers/notification.reducer';
import { AppDispatch } from './redux/store';
import { selectNotificationDetails } from './redux/selectors/notification.selector';
import { customerNotifications } from './redux/actions/notification.action';
import ReloadErrorModal from './components/ModalComponent/ReloadErrorModal/ReloadErrorModal';
import NewVersionModal from './components/ModalComponent/NewVersionModal/NewVersionModal';
import { useVersionCheck } from './custom_hooks/useVersionCheck';

const App: React.FC = () => {
  const { user } = useSelector((state: RootState) => selectAuthDetails(state)); 
  const { toaster } = useSelector((state: RootState) => selectSharedDetails(state)); 
  const { PATIENT_CONNECTED } = useSelector((state: RootState) => selectNotificationDetails(state));

  
  const dispatch = useDispatch<AppDispatch>();
  const socket = connectSocket();
  const { newVersionAvailable, reload, later } = useVersionCheck();

 useEffect(() => {
  if (!user?.patient_id) return;
  // used this useefect to connect socket on user login as as soon as user login we need to connect socket
  // also as soon as user logout patient id will be null and socket will be disconnected
  // so when the user input its credentials again it will connect socket using this useEffect
  const handleConnect = () => {
    console.log("Connected to server");
    socket.emit("PATIENT_CONNECTED", { patient_id: user.patient_id });
    dispatch(patientConnected(true));
  };

  socket.on("connect", handleConnect);

  socket.on("new_notification", () => {
    dispatch(customerNotifications({
      limit: 100,
      offset: 0,
      patient_id: user.patient_id,
    }));
  });

  if (socket.connected) {
    handleConnect();
  }

  return () => {
    socket.off("connect", handleConnect);
    socket.off("new_notification");
  };
}, [user, dispatch, socket]);

useEffect(() => {
  if (PATIENT_CONNECTED && !user?.patient_id) {
    //this useEffect is used to disconnect socket when user logout as soon as user logout patient id will be null
    console.log("PATIENT_DISCONNECTED");
    socket.emit("PATIENT_DISCONNECTED");
    socket.disconnect();
    dispatch(patientConnected(false));
  }
}, [user?.patient_id, PATIENT_CONNECTED, dispatch, socket]);

  return (
    <>
      {toaster.status && (
        <NotificationToaster status={toaster.status} message={toaster.message} type={toaster.type} duration={toaster.duration} />
      )}
      <ReloadErrorModal />
      <NewVersionModal show={newVersionAvailable} onReload={reload} onLater={later} />
      </>
    );
};

export default App;
